/* unplugin-vue-components disabled */import { render } from "./MmPayAgreement.vue?vue&type=template&id=0264d9a3&scoped=true"
import script from "./MmPayAgreement.vue?vue&type=script&lang=js"
export * from "./MmPayAgreement.vue?vue&type=script&lang=js"

import "./MmPayAgreement.vue?vue&type=style&index=0&id=0264d9a3&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0264d9a3"]])

export default __exports__